import { render, staticRenderFns } from "./modalNewPassword.vue?vue&type=template&id=6a27ae3b&scoped=true"
import script from "./modalNewPassword.vue?vue&type=script&lang=js"
export * from "./modalNewPassword.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/auth.scss?vue&type=style&index=0&id=6a27ae3b&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a27ae3b",
  null
  
)

export default component.exports